<template>
  <section id="mainContainer">
    <section class="login-page">
      <div class="login-container">
        <div class="admin-white-bg admin-custom-row">
          <div class="admin-login-left">
            <div class="admin-logo">
              <img src="@/assets/images/logo.svg" alt="Admin Logo" />
            </div>
            <h1>{{ constants.RESET_PASSWORD_TEXT }}</h1>
            <div class="admin-login-form">
              <form @submit.prevent="resetPassword" id="resetPwtForm">
                <div class="login-input">
                  <label>{{ constants.PASSWORD_LABEL }}</label>
                  <div class="password-input-container">
                    <input id="resetPwtInput" v-model="password" :type="showPassword ? 'text' : 'password'"
                      placeholder="Password" />
                    <div class="error-msg" v-if="!password || errorMsg ==='New password and confirm password do not match.'">{{ errorMsg }}</div>
                    <i :class="['password-icon', showPassword ? 'fas fa-eye-slash' : 'fas fa-eye']" id="resetPwtIcon"
                      @click="togglePasswordVisibility"></i>
                  </div>
                </div>

                <div class="login-input">
                  <label>{{ constants.CONFIRM_PASSWORD_LABEL }}</label>
                  <div class="password-input-container">
                    <input id="resetConPwtInput" v-model="confirmPassword"
                      :type="showConfirmPassword ? 'text' : 'password'" placeholder="Confirm Password" />
                    <div class="error-msg" v-if="!confirmPassword || errorMsg ==='Link Expired.Please Send the link again.'">{{ errorMsg }}</div>
                    <i :class="['password-icon', showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye']"
                      id="resetPwtSubmitBtn" @click="toggleConfirmPasswordVisibility"></i>
                  </div>
                </div>

                <button type="submit" class="primary-btn">
                  {{ constants.RESET_PASSWORD_BUTTON }}
                </button>
              </form>
            </div>
          </div>
          <div class="admin-login-right">
            <div class="admin-login-right-in">
              <h2>{{ constants.CREATED_NEW_PASSWORD_TEXT }}</h2>
              <p>
                {{
                  constants.YOUR_NEW_PASSWORD_MUST_BE_DIFFERENT_FROM_PREVIOUS_USED_PASSWORDS_TEXT
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer class="admin-site-footer">
      <div class="container">{{ constants.COPYRIGHT_TEXT }}</div>
    </footer>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import constants from "@/utils/en-US-Admin.json";
import { API_BASE_URL } from '@/config/api.config';
import axios from 'axios';
import Swal from 'sweetalert2';



export default defineComponent({
  name: 'ResetPassword',
  data() {
    return {
      password: '',
      confirmPassword: '',
      showPassword: false,
      showConfirmPassword: false,
      constants,
      errorMsg: '',
    };
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmPasswordVisibility() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    async resetPassword() {
      if (!this.password || !this.confirmPassword) {
        this.errorMsg = constants.THIS_FIELD_IS_REQUIRED;
        return;
      } 
      if(this.password !== this.confirmPassword){
        this.errorMsg = 'New password and confirm password do not match.';
        return;
      }else{
        this.errorMsg = '';
      }
      const email = this.$route.query.email;
      const token = this.$route.query.token;
      try {
        const response = await axios.post(API_BASE_URL + '/reset-password/', {
          email: email,
          token: token,
          new_password: this.password,
          confirm_password: this.confirmPassword

        });
        if (response.status === 200) {
          Swal.fire({
            icon: 'success',
            title: 'Password Updated Successfully!',
            showConfirmButton: false,
            timer: 1500
          })
          this.$router.push('/authority/login');
        }
      } catch (error: any) {
        this.errorMsg="Link Expired.Please Send the link again."
        console.log(error);
      }
    }
  },


});
</script>